import init from './lead/widget'

export default class Mag {

  leadWidget(setting = {}) {

    init(setting);
  }
}
